<template>
	<v-dialog
    v-model="dialogNoRolados.estatus"
    hide-overlay
    persistent
    max-width="1000"
  >
    <v-card>
      <v-card-title primary-title class="text-subtitle-1">
        Teachers - No rolados / Pueden cubrir
        <v-spacer />
        <v-btn
          class="mr-2"
          small
          dark
          color="green"
          tile
          @click="exportarExcelFiltrado"
        >
          <v-icon small>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text >

      	<v-row>
	      	<v-col cols="12" sm="6" md="3" class="pb-0">
	          <v-autocomplete
	            filled
	            :items="opcionesFiltroDia"
	            v-model="filtroDia"
	            item-text="label"
	            item-value="value"
	            label="Día y semana"
	            clearable
	            dense
	            single-line
	            hide-details
	          ></v-autocomplete>
	        </v-col>

	      	<v-col cols="12" sm="6" md="3" class="pb-0">
	          <v-autocomplete
	            filled
	            :items="opcionesHoras"
	            v-model="filtroHora"
	            label="Hora"
	            clearable
	            dense
	            single-line
	            hide-details
	          ></v-autocomplete>
	        </v-col>

	      	<v-col cols="12" sm="6" md="3" class="pb-0">
	          <v-text-field
	            v-model="search"
	            dense
	            filled
	            single-line
	            label="Buscar"
	            append-icon="mdi-magnify"
	            hide-details
	          ></v-text-field>  
	        </v-col>
      	</v-row>

        <v-tabs v-model="tabActiva" grow class="mt-4">
          <v-tab>Teachers no rolados</v-tab>
          <v-tab>Teachers que pueden cubrir</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabActiva">
          <v-tab-item>
            <v-data-table
              :headers="headersCerrados"
              :items="filterNoRolados"
              class="elevation-0 mt-2"
              dense
              :search="search"
            >
              <template v-slot:item.disponibilidad="{ item }">
                <v-chip class="mt-1" dark :color="item.disponibilidad.length ? 'green' : 'red'" small>{{ item.disponibilidad.length ? 'Si' : 'No' }}</v-chip>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-data-table
              :headers="headersCubrir"
              :items="filterPuedenCubrir"
              class="elevation-0 mt-2"
              dense
              :search="search"
            >
              <template v-slot:item.disponibilidad="{ item }">
                <v-chip class="mt-1" dark 
                v-if="filtroDia"
                v-for="(disp, j) in getChipsDisponibilidad(item.disponibilidadOrdenada)" :key="j" :color="getColorDia(disp.dia)"
                @click="dialogNoRolados.estatus = false, dialogNoRolados.teacher = item"
                >{{ disp.dia_label }} {{ disp.inicio || disp.hora_inicio }} - {{ disp.fin || disp.hora_fin }}</v-chip>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn 
        	color="black"
        	dark 
        	tile
        	@click="dialogNoRolados.estatus = false"
        >Cancelar</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>
<script>
import axios from 'axios';

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import { mapGetters, mapActions }  from 'vuex';
  import funcionesExcel        from '@/mixins/funcionesExcel'


	export default {

		components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

		props:[
			'dialogNoRolados',
			'prospectosCerrados',
			'gruposRoles',
			'teachers'
	  ],

    data: () => ({

    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      teacherActivos:[],
      disponibilidades: [],

      headersCerrados: [
        { text: 'Folio',          value: 'id_usuario'      },
        { text: 'Nombre',         value: 'nombre_completo' },  
        { text: 'Teléfono',       value: 'telefono1'       },  
        { text: 'Sucursal',       value: 'plantel'         },  
        { text: 'Motivo',         value: 'MOTIVO'          },  
        { text: 'Disponibilidad', value: 'disponibilidad'  },  
      ],

      headersCubrir: [
        { text: 'Folio',          value: 'id_usuario'      },
        { text: 'Nombre',         value: 'nombre_completo' },  
        { text: 'Teléfono',       value: 'telefono1'       },  
        { text: 'Sucursal',       value: 'plantel'         },  
        { text: 'Disponibilidad', value: 'disponibilidad'  },  
      ],
      search:'',
      tabActiva: 0,
      filtroDia: null,
      filtroHora: null,
      opcionesHoras: ['06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00'],

    }),

    async created(){

      await this.getDisponibilidades() 

    	this.teacherActivos = this.teachers.filter( el =>{ return el.activo == 1 })

    	let gruposActivos = this.gruposRoles.filter( el => { return el.deleted == 0 })

    	// PONER LOS MOTIVOS
	    const gruposEntreSemana   = gruposActivos.filter( el => { return el.sabado == 0 && el.domingo == 0 })

	    const teacher1EntreSemana = gruposEntreSemana.filter( el => { return el.id_teacher }).map((registro) => { return registro.id_teacher })
	    const teacher2EntreSemana = gruposEntreSemana.filter( el => { return el.id_teacher_2 }).map((registro) => { return registro.id_teacher_2 })

	    const idTeachersEntreSemana = teacher1EntreSemana.concat( teacher2EntreSemana )

	    // Sacando a los teacher que solo tienen sabatino o dominical y que no tienen en ningun otro grupo
	    const gruposSabaDomingos = gruposActivos.filter( el => { return el.sabado == 1 || el.domingo == 1 })

	    // Sacar los teacher que están en esos grupos
	    const teacher1SabaDom = gruposSabaDomingos.filter( el => { return !idTeachersEntreSemana.includes( el.id_teacher ) }).map((registro) => { return registro.id_teacher })
	    const teacher2SabaDom = gruposSabaDomingos.filter( el => { return !idTeachersEntreSemana.includes( el.id_teacher_2 ) }).map((registro) => { return registro.id_teacher_2 })

	    const idTeachersSabaDom = teacher1SabaDom.concat( teacher2SabaDom )

	    // Grupos solo entr semana
	    for( const i in this.teacherActivos ){
	      const { id_usuario } = this.teacherActivos[i]
	      if( idTeachersSabaDom.includes( id_usuario ) ){
	        this.teacherActivos[i]['MOTIVO'] = "SOLO SABADO Y/O DOMINGO"
	      }else if ( idTeachersEntreSemana.includes( id_usuario ) ) {
	        this.teacherActivos[i]['MOTIVO'] = "ROLADO ENTRE SEMANA"
	      }else{
	        this.teacherActivos[i]['MOTIVO'] = "NO ROLADO"
	      }

        const dispUsuario = this.disponibilidades.filter(el => el.usuario_registro == id_usuario)
        this.teacherActivos[i]['disponibilidad'] = dispUsuario
        this.teacherActivos[i]['disponibilidadOrdenada'] = this.ordenarDisponibilidades(dispUsuario)
	    }
    },

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela', 'drawer2', 'getEstatusLlamada', 'getNuevosProspectos']),
      /** Lunes 1–4 … Viernes 1–4: un bloque = ese día de esa semana. Sábado/Domingo 1–4: los 5 bloques (lu–vi con mismo índice) = un solo día. */
      opcionesFiltroDia() {
        const entreSemana = [
          { label: 'Lunes', value: 'lunes' },
          { label: 'Martes', value: 'martes' },
          { label: 'Miércoles', value: 'miercoles' },
          { label: 'Jueves', value: 'jueves' },
          { label: 'Viernes', value: 'viernes' }
        ]
        const finSemana = [
          { label: 'Sábado', value: 'sabado' },
          { label: 'Domingo', value: 'domingo' }
        ]
        const out = []
        for (const d of entreSemana) {
          for (let s = 1; s <= 4; s++) {
            out.push({ label: `${d.label} ${s}`, value: `${d.value}_${s}` })
          }
        }
        for (const d of finSemana) {
          for (let s = 1; s <= 4; s++) {
            out.push({ label: `${d.label} ${s}`, value: `${d.value}_${s}` })
          }
        }
        return out
      },
      filterNoRolados() {
        let lista = this.teacherActivos
        if (this.filtroDia) {
          const idsRoladosEseDia = this.getIdsRoladosEnDia(this.filtroDia)
          lista = lista.filter(t => !idsRoladosEseDia.includes(t.id_usuario))
        }
        if (this.filtroHora) lista = this.filtrarPorDisponibilidad(lista)
        return this.quitarDuplicados(lista)
      },
      filterPuedenCubrir() {
        let lista
        if (!this.filtroDia && !this.filtroHora) {
          lista = this.teacherActivos.filter(t => (t.disponibilidadOrdenada || []).length > 0)
        } else {
          lista = this.filtrarPorDisponibilidad(this.teacherActivos)
        }
        return this.quitarDuplicados(lista)
      }
    },

    methods:{
      /**
       * filtroKey: `lunes_1` … `viernes_4` → un solo bloque (ej. lu1 = lunes semana 1).
       * `sabado_N` / `domingo_N` → los 5 bloques luN, maN, miN, juN, viN cuentan como un solo día.
       */
      getIdsRoladosEnDia(filtroKey) {
        const grupos = (this.gruposRoles || []).filter(el => el.deleted == 0)
        if (!filtroKey || typeof filtroKey !== 'string') return []
        const parts = filtroKey.split('_')
        if (parts.length < 2) return []
        const dia = parts[0].toLowerCase()
        const semana = parseInt(parts[1], 10)
        if (!semana || semana < 1) return []

        const ids = []
        const entreSemana = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes']
        const prefMap = { lunes: 'lu', martes: 'ma', miercoles: 'mi', jueves: 'ju', viernes: 'vi' }

        if (entreSemana.includes(dia)) {
          const pref = prefMap[dia]
          const bloque = `${pref}${semana}`
          for (const gr of grupos) {
            if (gr[dia] != 1) continue
            const id = gr[bloque]
            if (id) ids.push(id)
          }
          return [...new Set(ids)]
        }

        if (dia === 'sabado') {
          const bloques = [`lu${semana}`, `ma${semana}`, `mi${semana}`, `ju${semana}`, `vi${semana}`]
          for (const gr of grupos) {
            if (gr.sabado != 1) continue
            for (const b of bloques) {
              if (gr[b]) ids.push(gr[b])
            }
          }
          return [...new Set(ids)]
        }

        if (dia === 'domingo') {
          const bloques = [`lu${semana}`, `ma${semana}`, `mi${semana}`, `ju${semana}`, `vi${semana}`]
          for (const gr of grupos) {
            if (gr.domingo != 1) continue
            for (const b of bloques) {
              if (gr[b]) ids.push(gr[b])
            }
          }
          return [...new Set(ids)]
        }

        return []
      },
      /** Para disponibilidad: solo el día de la semana (lunes…domingo), sin número de semana. */
      diaCalendarioDesdeFiltro(filtro) {
        if (!filtro || typeof filtro !== 'string') return null
        const dia = filtro.split('_')[0].toLowerCase()
        return dia
      },
      getChipsDisponibilidad(disponibilidadOrdenada) {
        const lista = disponibilidadOrdenada || []
        if (!this.filtroDia) return lista
        const ordenDias = { lunes: 1, martes: 2, miercoles: 3, jueves: 4, viernes: 5, sabado: 6, domingo: 7 }
        const normalizarDia = (d) => typeof d === 'number' ? d : (ordenDias[(d || '').toString().toLowerCase()] || 0)
        const diaCal = this.diaCalendarioDesdeFiltro(this.filtroDia)
        const diaFiltro = normalizarDia(diaCal)
        return lista.filter(d => normalizarDia(d.dia) === diaFiltro)
      },
      quitarDuplicados(lista) {
        const vistos = {}
        return lista.filter(t => {
          const id = t.id_usuario
          if (vistos[id]) return false
          vistos[id] = true
          return true
        })
      },
      filtrarPorDisponibilidad(lista) {
        if (!this.filtroDia && !this.filtroHora) return lista
        const ordenDias = { lunes: 1, martes: 2, miercoles: 3, jueves: 4, viernes: 5, sabado: 6, domingo: 7 }
        const normalizarDia = (d) => typeof d === 'number' ? d : (ordenDias[(d || '').toString().toLowerCase()] || 0)
        const diaCal = this.filtroDia ? this.diaCalendarioDesdeFiltro(this.filtroDia) : null
        const diaFiltro = diaCal ? normalizarDia(diaCal) : null
        const horaFiltro = (this.filtroHora || '').toString()
        return lista.filter(teacher => {
          const disp = teacher.disponibilidadOrdenada || []
          return disp.some(d => {
            if (diaFiltro && normalizarDia(d.dia) !== diaFiltro) return false
            if (!horaFiltro) return true
            const ini = (d.inicio || d.hora_inicio || '').toString()
            const fin = (d.fin || d.hora_fin || '').toString()
            return ini <= horaFiltro && horaFiltro < fin
          })
        })
      },
      getColorDia(dia) {
        if (typeof dia === 'number') {
          if (dia === 6) return 'orange'
          if (dia === 7) return 'purple'
          return 'blue'
        }
        const d = (dia || '').toString().toLowerCase()
        if (d === 'sabado') return 'orange'
        if (d === 'domingo') return 'purple'
        return 'blue'
      },
      getNombreDia(dia) {
        const mapa = { 1: 'Lunes', 2: 'Martes', 3: 'Miércoles', 4: 'Jueves', 5: 'Viernes', 6: 'Sábado', 7: 'Domingo', lunes: 'Lunes', martes: 'Martes', miercoles: 'Miércoles', jueves: 'Jueves', viernes: 'Viernes', sabado: 'Sábado', domingo: 'Domingo' }
        if (dia === null || dia === undefined) return '—'
        const k = (typeof dia === 'string' ? dia.toLowerCase() : dia)
        return mapa[k] || String(dia)
      },
      ordenarDisponibilidades(lista) {
        const ordenDias = { lunes: 1, martes: 2, miercoles: 3, jueves: 4, viernes: 5, sabado: 6, domingo: 7 }
        const sorted = lista.slice().sort((a, b) => {
          const diaA = typeof a.dia === 'number' ? a.dia : (ordenDias[(a.dia || '').toLowerCase()] || 0)
          const diaB = typeof b.dia === 'number' ? b.dia : (ordenDias[(b.dia || '').toLowerCase()] || 0)
          if (diaA !== diaB) return diaA - diaB
          const horaA = (a.inicio || a.hora_inicio || '').toString()
          const horaB = (b.inicio || b.hora_inicio || '').toString()
          return horaA.localeCompare(horaB)
        })
        const vistos = {}
        const sinDuplicados = sorted.filter(d => {
          const dia = (d.dia || '').toString().toLowerCase()
          const ini = (d.inicio || d.hora_inicio || '').toString()
          const fin = (d.fin || d.hora_fin || '').toString()
          const key = dia + '|' + ini + '|' + fin
          if (vistos[key]) return false
          vistos[key] = true
          return true
        })
        return sinDuplicados.map(d => Object.assign({}, d, { dia_label: this.getNombreDia(d.dia) }))
      },
      cerrar(){
      	this.dialogNoRolados.estatus = false
      	this.$emit('initialize')
      },

      exportar( ){

        this.exportExcel( this.prospectosCerrados  , 'prospectosCerrados')
      },

      /** Texto para Excel: mismos chips que la tabla cuando hay filtro día, si no todas las franjas. */
      formatDisponibilidadTextoExport(item) {
        const lista = this.filtroDia
          ? this.getChipsDisponibilidad(item.disponibilidadOrdenada)
          : (item.disponibilidadOrdenada || [])
        if (!lista.length) return ''
        return lista
          .map((d) => {
            const ini = d.inicio || d.hora_inicio || ''
            const fin = d.fin || d.hora_fin || ''
            return (d.dia_label || this.getNombreDia(d.dia)) + ' ' + ini + ' - ' + fin
          })
          .join('; ')
      },

      itemCoincideBusqueda(item, sn, tabCerrados) {
        if (!sn) return true
        const q = String(sn).trim().toLowerCase()
        const partes = [
          item.id_usuario,
          item.nombre_completo,
          item.telefono1,
          item.plantel,
          item.MOTIVO,
        ]
        if (tabCerrados) {
          partes.push(item.disponibilidad && item.disponibilidad.length ? 'sí si' : 'no')
        }
        partes.push(this.formatDisponibilidadTextoExport(item))
        return partes.join(' ').toLowerCase().includes(q)
      },

      exportarExcelFiltrado() {
        const sn = this.search || ''
        let items
        let name
        if (this.tabActiva === 0) {
          items = this.filterNoRolados.filter((i) => this.itemCoincideBusqueda(i, sn, true))
          name = 'Teachers_no_rolados_filtrado'
        } else {
          items = this.filterPuedenCubrir.filter((i) => this.itemCoincideBusqueda(i, sn, false))
          name = 'Teachers_pueden_cubrir_filtrado'
        }
        const rows =
          this.tabActiva === 0
            ? items.map((item) => ({
                Folio: item.id_usuario,
                Nombre: item.nombre_completo,
                Teléfono: item.telefono1,
                Sucursal: item.plantel,
                Motivo: item.MOTIVO,
                Disponibilidad: item.disponibilidad && item.disponibilidad.length ? 'Sí' : 'No',
              }))
            : items.map((item) => ({
                Folio: item.id_usuario,
                Nombre: item.nombre_completo,
                Teléfono: item.telefono1,
                Sucursal: item.plantel,
                Disponibilidad: this.formatDisponibilidadTextoExport(item),
              }))
        if (!rows.length) {
          this.validarErrorDirecto('No hay filas para exportar con los filtros actuales.')
          return
        }
        this.exportExcel(rows, name)
      },

      getDisponibilidades( ){
        this.cargar = true
        return this.$http.get('cobertura.all').then(response=>{
          this.disponibilidades = response.data
          this.cargar = false
        }).catch(error=>{
          this.validarError(error.response.data.message)
        }).finally(()=>{ this.cargar = false })
      }
    }
	}
</script>
